{
  "possibleTypes": {
    "V2LlamaLlamaCoatColor": [
      "V2LlamaLlamaCoatColorHex",
      "V2LlamaLlamaCoatColorNamed",
      "V2LlamaLlamaCoatColorRolloutConfigGatedVariant"
    ],
    "V2LlamaLlamaCoatPattern": [
      "V2LlamaLlamaCoatPatternNewerVersionVariant",
      "V2LlamaLlamaCoatPatternRolloutConfigGatedVariant",
      "V2LlamaLlamaCoatPatternSolid",
      "V2LlamaLlamaCoatPatternSpotted",
      "V2LlamaLlamaCoatPatternUnknownVariant"
    ]
  }
}